import { useTranslation } from 'react-i18next';

import { UniError } from './Illustrations/UniError';
import { StatusPage } from './StatusPage';

export const MobileUnavailable = () => {
	const { t } = useTranslation('monarch');

	return (
		<StatusPage
			graphic={<UniError title={t('status.missing_image_title')} />}
			heading={t('status.mobile_unavailable_title')}
			subheading={t('status.mobile_unavailable_description')}
		/>
	);
};
